/**
 * 관리자 오더 통계
 * ($j.Pages.Admin.OrderStat / body data-page-name="OrderStat")
 *
 * 발주일 기준 월/년 발주·완료·취소·거래액 추이 + 상태/종류/장비/지역 분해.
 */
export default class OrderStat {
    constructor() {
        this.trendChart = null;
        this.palette = ['#0d6efd', '#198754', '#fd7e14', '#6610f2', '#20a8a8', '#dc3545', '#6c757d', '#e83e8c'];
    }

    initialize() {
        $('#osRefresh').on('click', () => this._load(true));
        $('#osPeriod').on('change', () => this._load());
        this._load();
    }

    async _load(nocache = false) {
        try {
            const [unit, periods] = String($('#osPeriod').val()).split(':');
            const data = { unit, periods };
            if (nocache) data.nocache = 1;
            const res = await $.ajax({ url: '/adm/ajax/stat/orders/data', type: 'get', data });
            if (!res.ok) return;
            this._renderSummary(res.summary);
            this._renderTrend(res.trend);
            if (res.cached_at) $('#osCachedAt').text(`집계 ${res.cached_at}`);
        } catch (e) {
            console.error('오더 통계 로드 실패', e);
        }
    }

    _renderSummary(s) {
        $('#osTotal').text(this._c(s.total));
        $('#osAvg').text(`${s.avg_label} ${this._c(s.avg)}건`);
        $('#osDone').text(this._c(s.done));
        $('#osDoneRate').text(`완료율 ${s.done_rate}%`);
        $('#osCancel').text(this._c(s.cancel));
        $('#osCancelRate').text(`취소율 ${s.cancel_rate}%`);
        $('#osGmv').text(this._won(s.gmv));
        $('#osApp').text(s.app_pct + '%');
    }

    _renderTrend(trend) {
        const ctx = document.getElementById('osTrendChart').getContext('2d');
        if (this.trendChart) this.trendChart.destroy();
        const labels = trend.map(t => this._fmt(t.bucket));
        this.trendChart = new Chart(ctx, {
            data: {
                labels,
                datasets: [
                    { type: 'bar', label: '발주', data: trend.map(t => t.orders), backgroundColor: '#0d6efd', yAxisID: 'y', order: 3 },
                    { type: 'bar', label: '완료', data: trend.map(t => t.done), backgroundColor: '#198754', yAxisID: 'y', order: 3 },
                    { type: 'bar', label: '취소', data: trend.map(t => t.cancel), backgroundColor: '#dc3545', yAxisID: 'y', order: 3 },
                    { type: 'line', label: '거래액', data: trend.map(t => t.gmv), borderColor: '#fd7e14', backgroundColor: '#fd7e14', tension: .25, yAxisID: 'y1', order: 1 },
                ]
            },
            options: {
                responsive: true, maintainAspectRatio: false,
                scales: {
                    y: { beginAtZero: true, position: 'left', title: { display: true, text: '건수' } },
                    y1: { beginAtZero: true, position: 'right', title: { display: true, text: '거래액' }, grid: { drawOnChartArea: false },
                        ticks: { callback: (v) => this._won(v) } },
                },
                plugins: {
                    tooltip: { callbacks: {
                        afterBody: (items) => {
                            const t = trend[items[0].dataIndex];
                            return `거래액 ${this._won(t.gmv)}` + (t.is_partial ? ' (진행중)' : '');
                        }
                    } }
                }
            }
        });
    }

    _bars(sel, items, limit) {
        if (!items || !items.length) { $(sel).html('<span class="text-muted small">없음</span>'); return; }
        const list = limit ? items.slice(0, limit) : items;
        const total = items.reduce((a, b) => a + b.count, 0);
        const max = Math.max(...list.map(i => i.count));
        const html = list.map((i, idx) => {
            const w = max > 0 ? Math.round(i.count / max * 100) : 0;
            const pct = total > 0 ? Math.round(i.count / total * 100) : 0;
            const color = i.label === '취소' ? '#dc3545' : this.palette[idx % this.palette.length];
            return `<div class="row-item">
                <span class="lbl" title="${i.label}">${i.label}</span>
                <span class="bar" style="width:${Math.max(w, 3)}%;background:${color}"></span>
                <span class="val">${this._c(i.count)} (${pct}%)</span>
            </div>`;
        }).join('');
        $(sel).html(html);
    }

    _won(n) {
        n = Number(n || 0);
        if (n >= 1e8) return (n / 1e8).toFixed(1) + '억';
        if (n >= 1e4) return Math.round(n / 1e4).toLocaleString() + '만';
        return n.toLocaleString();
    }

    _fmt(b) {
        const s = String(b);
        return s.length === 6 ? `${s.slice(2, 4)}.${s.slice(4)}` : s;
    }

    _c(n) { return Number(n || 0).toLocaleString(); }

    destroy() {
        if (this.trendChart) { this.trendChart.destroy(); this.trendChart = null; }
    }
}
